document.addEventListener("DOMContentLoaded", function () {
  // Sign Up Get OTP
  async function signUpGetOTPDetails() {
    /* Validation */
    const isFormValid = await validateSignupForm();
    if (!isFormValid) {
      return;
    }
    /* Validation */

    const signUpEmail = document.querySelector("#signUpEmail").value;
    const signUpPhone = document.querySelector("#signUpPhone").value;

    // Check user registration status first
    try {
      const statusCheckResult = await checkUserregisterStatus(signUpPhone, signUpEmail);
      if (statusCheckResult.isBlocked || statusCheckResult.status === "blocked") {
        displayError(
        "#signUpPhoneError",
        "We have detected suspicious activity in your account, and it is currently under review."
        );
        return;
      }   
    } catch (statusError) {
      console.error("Error checking user status:", statusError);
    }


    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const register = {
      mobileNumber: signUpPhone,
      email: signUpEmail,
    };

    const encrypted = CryptoUtil.encryptRequest("POST", register);

    myHeaders.append("seal", encrypted.seal);

    const raw = JSON.stringify({
      iv: encrypted.iv,
      payload: encrypted.payload,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${window.Base_Url.Base_Url}/services/loginservice/rajnigandha/V3/register/sendotpV3`,
        requestOptions
      );
      const data = await response.json();
      const result = CryptoUtil.decryptResponse(data);
      console.log("registerMobilesign", result);  

      if (result.success === true) {
        document.querySelector("#signUpGetOTP").style.display = "none";
        document.querySelector("#signUpOTP").style.display = "block";
        document.querySelector("#signUpVerifyOTP").style.display = "block";
        document.querySelector("#signUpMsgOTP").style.display = "block";

        // Disabled Phone Number
        const signUpPhoneInput = document.querySelector("#signUpPhone");
        if (!signUpPhoneInput.hasAttribute("disabled")) {
          signUpPhoneInput.setAttribute("disabled", "true");
        }
        // Disabled Phone Number

        startTimer("#signUpTimer", "#signUpResend", "#signUpResendTimer"); // Timer
      } else if (
        result.success == false &&
        result.message ===
          "Please wait for this request to expire to request for another OTP."
      ) {
        displayError(
          "#signUpPhoneError",
          "Please wait for 3 min to expire current OTP"
        );
        document.querySelector("#signUpGetOTP").style.display = "none";

        const expiresAt = result.expiresAt;
        if (!expiresAt) return;

        const expiryTime = convertToDate(expiresAt);
        const currentTime = new Date();

        if (currentTime < expiryTime) {
          const remainingTime = expiryTime - currentTime;
          startCountdown(
            remainingTime,
            "#remaingTimerSignUp",
            "#signUpPhoneError",
            "#signUpGetOTP"
          );
        }
      } else {
        const message = result.message.toLowerCase();
        if (message.includes("customer already exists with email")) {
          if (signUpEmail) {
            displayError(
              "#signUpEmailError",
              "This email ID is already registered with us."
            );
          }
        } else if (message.includes("customer already exists. please login.")) {
          if (signUpPhone) {
            displayError(
              "#signUpPhoneError",
              "This mobile number is already registered with us."
            );
          }
        }
      }
    } catch (error) {
      const plainData = error.split("|")[0],
        EncKey = error.split("|")[1].split("%%")[0];
      const errorData = window.Decrypt(plainData, EncKey) || {};
      console.error("Error Fetching OTP:", errorData);
    }
  }


    // Helper function to check user register status
    async function checkUserregisterStatus(mobile, email) {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");  
      const requestBody = {
        mobile: '+91'+mobile,
        email: email
      }; 
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(requestBody),
        redirect: "follow",
      };
      try {
        const response = await fetch(
          `${window.Base_Url.Base_Url}/status-flag/get-user-status`,
          requestOptions
        );
        const data = await response.json(); 
        console.log("registerMobile", requestBody);       
        return data;
      } catch (error) {
        console.error("Error in checkUserregisterStatus:", error);
        throw error;
      }
    }


  const signUpGetOTP = document.querySelector("#signUpGetOTP");
  if (signUpGetOTP) {
    signUpGetOTP.addEventListener("click", function () {
      event.preventDefault();
      signUpGetOTPDetails();
    });
  }

  // Sign Up Verify OTP
  async function signUpVerifyOTPDetails() {
    /* Validation */
    const isFormValid = await validateSignupForm();
    if (!isFormValid) {
      return;
    }
    /* Validation */

    const firstName = document.querySelector("#customerFirstName")?.value;
    const lastName = document.querySelector("#customerLastName")?.value;
    const signUpEmail = document.querySelector("#signUpEmail")?.value;
    const signUpPhone = document.querySelector("#signUpPhone")?.value;
    const signUpOTP = document.querySelector("#signUpOTP")?.value;
    const signUpPincode = document.querySelector("#signUpPincode")?.value;
    const signUpState = document.querySelector("#signUpState")?.value;
    const signUpCity = document.querySelector("#signUpCity")?.value;
    const signUpDistrict = document.querySelector("#signUpDistrict")?.value;
    const signUpAddress = document.querySelector("#signUpAddress")?.value;

    // SignUp OTP Validation
    if (!signUpOTP) {
      displayError("#signUpOTPError", "OTP is Required");
      isValid = false;
    } else if (!/^\d{6}$/.test(signUpOTP)) {
      displayError("#signUpOTPError", "Invalid OTP");
      isValid = false;
    }

    // Disable Verify Button
    const verifyButton = document.querySelector("#signUpVerifyOTP");
    verifyButton.disabled = true;
    document.querySelector(".signUpLoader").style.display = "flex";

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const registerData = {
      mobileNumber: signUpPhone,
      email: signUpEmail,
      first_name: firstName,
      last_name: lastName,
      otp: signUpOTP,
      pincode: signUpPincode,
      state: signUpState,
      city: signUpCity,
      district: signUpDistrict,
      address1: signUpAddress,
      address2: "",
      note: "",
    };

    const encrypted = CryptoUtil.encryptRequest("POST", registerData);

    myHeaders.append("seal", encrypted.seal);

    const raw = JSON.stringify({
      iv: encrypted.iv,
      payload: encrypted.payload,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${window.Base_Url.Base_Url}/services/loginservice/rajnigandha/V3/register/verifyotpV3`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        const result = CryptoUtil.decryptResponse(data);
        verifyButton.disabled = false;

        if (result.success === true) {
          const urlParams = new URLSearchParams(window.location.search);

          if (urlParams.has("checkout_url")) {
            const currentURL = window.location.href.split("?")[0];
            const redirectURL =
              currentURL + "?" + urlParams.toString() + "&trigger=true";

            window.location.href = result.url;
            setTimeout(() => {
              window.location.href = redirectURL;
            }, 1000);
          } else if (urlParams.has("subcribecheckout_url")) {
            const currentUrl = window.location.href.split("?")[0];
            const redirectUrl =
              currentUrl + "?" + urlParams.toString() + "&trigger=true";

            window.location.href = result.url;
            setTimeout(() => {
              window.location.href = redirectUrl;
            }, 1000);
          } else {
            setTimeout(() => {
              window.location.href = result.url;
              document.querySelector(".signUpLoader").style.display = "none";
            }, 3000);
          }
        } else {
          document.querySelector(".signUpLoader").style.display = "none";
          displayError("#signUpOTPError", result.message);
        }
      })
      .catch((data) => {
        const plainData = data?.response.data.split("|")[0],
          EncKey = data?.response.data.split("|")[1].split("%%")[0];
        const error = window.Decrypt(plainData, EncKey) || {};
        document.querySelector(".signUpLoader").style.display = "none";
        verifyButton.disabled = false;
        console.error(error);
      });
  }

  const signUpVerifyOTP = document.querySelector("#signUpVerifyOTP");
  if (signUpVerifyOTP) {
    signUpVerifyOTP.addEventListener("click", function () {
      signUpVerifyOTPDetails();
    });
  }

  // Sign In Get OTP
  async function signInGetOTPDetails() {
    const checkboxSignin = document.querySelector("#checkboxSignin");

    // Checkbox Validation
    if (!checkboxSignin.checked) {
      displayError(
        "#signInPhoneError",
        "You must agree to the Terms & Conditions"
      );
      return;
    }

    /* Validation */
    if (!validateLoginPhone()) {
      return;
    }
    /* Validation */

    const signInPhone = document.querySelector("#signInPhone").value;
    const signUpPhoneAutofill = document.querySelector("#signUpPhone");
    const noemail = ' ';

    // Check user login status first
    try {
      const statusCheckLoginResult = await checkUserLoginStatus(signInPhone, noemail);
      if (statusCheckLoginResult.isBlocked || statusCheckLoginResult.status === "blocked") {
        displayError(
        "#signInPhoneError",
        "We have detected suspicious activity in your account, and it is currently under review."
        );
        return;
      }   
    } catch (statusError) {
      console.error("Error checking user status:", statusError);
    }


    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const login = {
      mobileNumber: signInPhone,
    };

    const encrypted = CryptoUtil.encryptRequest("POST", login);

    myHeaders.append("seal", encrypted.seal);

    const raw = JSON.stringify({
      iv: encrypted.iv,
      payload: encrypted.payload,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${window.Base_Url.Base_Url}/services/loginservice/rajnigandha/V3/login/sendotpV3`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        const result = CryptoUtil.decryptResponse(data);
        console.log("blockedDataMobile", login);

        if (result.success == true) {
          document.querySelector("#signInGetOTP").style.display = "none";
          document.querySelector("#signInOTP").style.display = "block";
          document.querySelector("#signInVerifyOTP").style.display = "block";
          document.querySelector("#signInMsgOTP").style.display = "block";

          // Disabled Phone Number
          const signInPhoneInput = document.querySelector("#signInPhone");
          if (!signInPhoneInput.hasAttribute("disabled")) {
            signInPhoneInput.setAttribute("disabled", "true");
          }
          // Disabled Phone Number

          startTimer("#signInTimer", "#signInResend", "#signInResendTimer"); // Timer
        } else if (
          result.success == false &&
          result.message ===
            "Please wait for this request to expire to request for another OTP."
        ) {
          displayError(
            "#signInPhoneError",
            "Please wait for 3 min to expire current OTP"
          );
          document.querySelector("#signInGetOTP").style.display = "none";

          const expiresAt = result.expiresAt;
          if (!expiresAt) return;

          const expiryTime = convertToDate(expiresAt);
          const currentTime = new Date();

          if (currentTime < expiryTime) {
            const remainingTime = expiryTime - currentTime;
            startCountdown(
              remainingTime,
              "#remaingTimer",
              "#signInPhoneError",
              "#signInGetOTP"
            );
          }
        } else {
          displayError("#signInPhoneError", result.message);
          // Trigger Sign Up If User is Not Registered & Autofill Mobile Number
          if (
            result.message.includes("not a registered customer") ||
            result.message.includes("please create a new account")
          ) {
            document.querySelector("#showSignUp").click();
            signUpPhoneAutofill.value = signInPhone;
          }
          // Trigger Sign Up If User is Not Registered & Autofill Mobile Number
        }
      })
      .catch((data) => {
        const plainData = data?.response.data.split("|")[0],
          EncKey = data?.response.data.split("|")[1].split("%%")[0];
        const error = window.Decrypt(plainData, EncKey) || {};
        console.error(error);
      });
  }

      // Helper function to check user login status
      async function checkUserLoginStatus(mobile, noemail) {
          const myHeaders = new Headers();
          myHeaders.append("Content-Type", "application/json");  
          const requestBody = {
            mobile: '+91'+mobile,
            email: noemail
          }; 
          const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: JSON.stringify(requestBody),
            redirect: "follow",
          };
          try {
          const response = await fetch(
          `${window.Base_Url.Base_Url}/status-flag/get-user-status`,
          requestOptions
          );
          const data = await response.json();  
          console.log("blockedData", requestBody);      
          return data;
          } catch (error) {
          console.error("Error in checkUserLoginStatus:", error);
          throw error;
          }
      }


  const signInGetOTP = document.querySelector("#signInGetOTP");
  signInGetOTP?.addEventListener("click", function () {
    const checkboxSignin = document.querySelector("#checkboxSignin");
    if (checkboxSignin.checked) {
      signInGetOTPDetails();
    } else {
      displayError(
        "#signInPhoneError",
        "You must agree to the T&C and Privacy Policy."
      );
    }
  });

  // Sign In Verify OTP
  function signInVerifyOTPDetails() {
    const checkboxSignin = document.querySelector("#checkboxSignin");

    // Checkbox Validation
    if (!checkboxSignin.checked) {
      displayError(
        "#signInPhoneError",
        "You must agree to the T&C and Privacy Policy."
      );
      return;
    }

    /* Validation */
    if (!validateLoginOTP()) {
      return;
    }
    /* Validation */

    const signInPhone = document.querySelector("#signInPhone").value;
    const signInOTP = document.querySelector("#signInOTP").value;

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const loginData = {
      mobileNumber: signInPhone,
      otp: signInOTP,
    };

    const encrypted = CryptoUtil.encryptRequest("POST", loginData);

    myHeaders.append("seal", encrypted.seal);

    const raw = JSON.stringify({
      iv: encrypted.iv,
      payload: encrypted.payload,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    document.getElementById("signInVerifyOTP").innerText = "Verifying...";

    fetch(
      `${window.Base_Url.Base_Url}/services/loginservice/rajnigandha/V3/login/verifyotpV3`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        const result = CryptoUtil.decryptResponse(data);

        document.getElementById("signInVerifyOTP").innerText = "Verify OTP & Login";

        if (result.success === true) {

            // const hash = CryptoUtil.SHA256(signInPhone).toString();
            // console.log("lllllllllll",hash);
            // console.log("kkkkkkkkkk", signInPhone);

            


          const urlParams = new URLSearchParams(window.location.search);

          if (urlParams.has("subcribecheckout_url")) {
            const currentURL = window.location.href.split("?")[0];
            const redirectURL =
              currentURL + "?" + urlParams.toString() + "&trigger=true";

            window.location.href = result.url;
            setTimeout(() => {
              window.location.href = redirectURL;
            }, 1000);
          } else {
            window.location.href = result.url;
          }
        } else {
          displayError("#signInOTPError", result.message);
        }
      })
      .catch((data) => {
        const plainData = data?.response.data.split("|")[0],
          EncKey = data?.response.data.split("|")[1].split("%%")[0];
        const error = window.Decrypt(plainData, EncKey) || {};
        console.error(error);
      });
  }

  const signInVerifyOTP = document.querySelector("#signInVerifyOTP");
  signInVerifyOTP?.addEventListener("click", function () {
    const checkboxSignin = document.querySelector("#checkboxSignin");
    if (checkboxSignin.checked) {
      signInVerifyOTPDetails();
    } else {
      displayError(
        "#signInOTPError",
        "You must agree to the T&C and Privacy Policy."
      );
    }
  });

  // Sign In Resend OTP
  var signinResend = document.querySelector("#signInResend a");
  if (signinResend) {
    signinResend.addEventListener("click", function () {
      signInGetOTPDetails();
    });
  }

  // Sign Up Resend OTP
  var signupResend = document.querySelector("#signUpResend a");
  if (signupResend) {
    signupResend.addEventListener("click", function () {
      signUpGetOTPDetails();
    });
  }

  // Sign In & Sign Up OTP Timer
  function startTimer(timerOTP, resendOTP, timerRunning) {
    const timerOTPElement = document.querySelector(timerOTP);
    const resendOTPElement = document.querySelector(resendOTP);
    const timerRunningElement = timerOTPElement.querySelector(timerRunning);
    let timeLeft = 300;

    resendOTPElement.style.display = "none";
    timerOTPElement.style.display = "block";

    const formatTime = (totalSeconds) => {
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;
      return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
    };

    timerRunningElement.innerText = `Resend OTP in ${formatTime(timeLeft)}`;
    const intervalTime = setInterval(() => {
      timeLeft -= 1;
      if (timeLeft <= 0) {
        clearInterval(intervalTime);
        timerOTPElement.style.display = "none";
        resendOTPElement.style.display = "block";
      } else {
        timerRunningElement.innerText = `Resend OTP in ${formatTime(timeLeft)}`;
      }
    }, 1000);
  }

  // Expired Date Format
  function convertToDate(timeStr) {
    const currentDate = new Date();
    const timeParts = timeStr.split(" ");
    const [hours, minutes, seconds] = timeParts[0].split(":");
    const amPm = timeParts[1].toLowerCase();

    let hour = parseInt(hours, 10);
    if (amPm === "pm" && hour < 12) {
      hour += 12;
    } else if (amPm === "am" && hour === 12) {
      hour = 0;
    }

    return new Date(
      currentDate.setHours(hour, parseInt(minutes), parseInt(seconds), 0)
    );
  }

  // Expired Timer
  function startCountdown(
    duration,
    timerSelector,
    errorSelector,
    getOtpButtonSelector
  ) {
    let timer = duration;
    const interval = setInterval(() => {
      const minutes = Math.floor(timer / 60000);
      const seconds = Math.floor((timer % 60000) / 1000);

      $(timerSelector).show().text(`Remaining Time: ${minutes}m ${seconds}s`);
      timer -= 1000;
      if (timer <= 0) {
        clearInterval(interval);
        $(errorSelector + ", " + timerSelector).hide();
        $(getOtpButtonSelector).show();
      }
    }, 1000);
  }
});

$(document).ready(function () {
  const params = new URLSearchParams(window.location.search);
  if (params.has("trigger")) {
    setTimeout(() => {
      $(".header__icon--cart").get(0).click();
      window.history.replaceState({}, "", window.location.pathname);
    }, 1000);
  }
});
